import { render } from "./Next.vue?vue&type=template&id=d61412d2"
import script from "./Next.vue?vue&type=script&lang=js"
export * from "./Next.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__